import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import User from './user/User';
import ResetPassword from './resetPassword/resetPassword';
import Registration from './registration/Registration';
import Proposal from './proposal/Proposal';
import PersonalData from './personalData/PersonalData';
import Auth from './auth/Auth';
import Calendar from './calendar/Calendar';
import Language from './language/Language';
import ModeratorSearch from './moderator-search/moderatorSearch';
import RoleList from './role-list/RoleList';
import Council from './council/Council';
import Pass from './Pass/Pass';
import Invitation from './Invitation/Invitation.js'
import NewProposal from './newProposal/newProposal.js'
import Logout from './Logout/Logout';
import Statistic from './statictic';
import OldApplications from './oldApplications';
import { errorHelper, messageHelper } from './helper.js';

import {
  AUTH_URL, EQUIMENT_URL,
  PROPOSAL_DETAIL_URL,
  FILE_POST_URL,
  FILES_LIST_URL,
  REQUEST_URL,
  INDIVIDUAL_URL,
  PDF_URL,
  EXPORT_LIST_TO_EXCEL_URL,
  ADD_COMMENT_BS_URL,
  PROPOSAL_BS_ACTION_URL,
  ADD_EXPERIMENT_BS_URL,
  REFERENCES_URL,
  DOMEN,
  PROPOSAL_AVAILABLE_ACTIONS_URL,
  UPDATE_PROPOSAL_STATUS_URL,
  CALENDAR_UPLOAD_URL,
  BS_LIST_URL,
  PROPOSAL_EXPERTS_URL,
  GET_EXPERT_PROPOSAL_LIST_URL,
  COUNCIL_EXPORT_TO_DOCX_URL,
  PROPOSAL_CHANGE_TEAM_URL,
  GET_ACTION_HISTORY_URL,
  EXPORT_CALENDAR_EXCEL_URL,
} from '../../vars';

Vue.use(Vuex);

/**
 * @namespace Main
 */
export default new Vuex.Store({
  state: {
    newProposal: {},
    isLoggedIn: '',
    nameUser: '',
    proposal: null,
    equiment: null,
    individual: null,
    exper: null,
    inputAll: [],
    profile: null,
    overlay: false,
    currentStation: null,
    stations: [],
    bs_list: null,
    base_proposal_id: null,
    kisi_status: null,
    need_load_kisi_status: false,
    show_helper_dialog: false,
    helper_data: {
      'header': '',
      'text': '',
    }
  },
  mutations: {
    UPDATE_BASE_PROPOSAL_ID(state, data){
      state.base_proposal_id = data;
    },
    UPDATE_OVERLAY(state, data) {
      state.overlay = data;
    },
    UPDATE_NAME_USER(state, data) {
      state.nameUser = data;
    },
    ADD_DATA_NEW_PROPOSAL(state, payload) {
      state.newProposal = { ...state.newProposal, ...payload };
    },
    SET_IS_LOGGED_IN(state, payload) {
      state.isLoggedIn = payload.id;
    },
    GET_LIST_PROPOSAL(state, payload) {
      state.proposal = payload;
    },
    UPDATE_EQUIMENT(state, data) {
      state.equiment = data.data;
      state.equiment.forEach(item => {
        if(item.type == 'station'){
            state.stations[item.id] = item
        }
      })
      this.commit('INIT_CALENDAR_LIST', state.equiment);
    },
    UPDATE_BS(state, data) {
      state.bs_list = {}
      data.data.forEach((item) => {
        state.bs_list[item.id] = item
      });
    },
    UPDATE_INDIVIDUAL(state, data) {
      state.individual = data.data;
    },
    UPDATE_EXPER(state, exper) {
      // console.log('EEEE', exper);
      state.exper = exper;
    },
    UPDATE_INPUT_ALL(state, data) {
      // data.status.forEach((item) => {
      //   if (item.file !== null) data.files.push(item.file);
      // });

      state.inputAll = data;
    },

    UPDATE_PROFILE(state, data) {
      state.profile = data;
    },
    UPDATE_INPUT_ALL_COMMENTS(state, data) {
      state.inputAll.comments.push(data);
    },

    UPDATE_TEAM(state, data) {
      state.inputAll.all_teams = data;
    },
    
    SET_CURRENT_STATION(state, data) {
      state.currentStation = data;
    },
    SET_LOAD_KISI_STATUS(state, value){
      state.need_load_kisi_status = value
    },
    UPDATE_KISI_STATUS(state, data){
      state.need_load_kisi_status = false
      state.kisi_status = data

      if(Math.abs(new Date() - new Date(data['created_at'])) < 600000){  // 10 minute
        setTimeout(() => {
          state.need_load_kisi_status = true
        }, 60000) // 1 minute    
      }
      else{
        messageHelper('нет актуальных данных', 'info', 2000);
      }
    },
    UPDATE_HELPER_DIALOG(state, data){
      if(data.show){
        state.helper_data = data.helper_data
        state.show_helper_dialog = true
      }
      else{
        state.helper_data = {
          'header': '',
          'text': '',
        }
        state.show_helper_dialog = false
      }
    },
  },

  actions: {
    async logged(ctx, payload) {
      if (payload.token) {
        try {
          // console.log('payload ---> ', payload);
          axios.get(`${AUTH_URL}profile/`, {
            headers: {
              Authorization: `Token ${payload.token}`,
            },
          })
            .then((res) => {
              ctx.commit('SET_IS_LOGGED_IN', { id: res.data.id });
            })
            .catch((e) => {
              errorHelper(e);
              messageHelper(e.response.data.detail, 'error', 6000, e);
            });
        } catch (ex) {
          console.log('ex store logged ---> ', ex);
          messageHelper(ex.response.data.detail, 'error', 6000, ex);
        }
      }
    },
    // /////

    /**
     * Получает данные о пользователе и записывает
     * @param {Object} ctx
     * @param {Number|String} id Идентификатор профиля
     * @throws {Object} Ошибка получения данных
     *
     * @memberof Main
     */
    async GET_PROFILE(ctx, id) {
      if (id) {
        try {
          const res = await axios.get(`${AUTH_URL}profile/?id=${id}`, {
            headers: {
              Authorization: `Token ${localStorage.token}`,
            },
          });

          await ctx.commit('UPDATE_PROFILE', res);
          await ctx.commit('SET_IS_LOGGED_IN', res.data);
        } catch (e) {
          if (e.response.data.detail !== 'Недопустимый токен.') {
            errorHelper(e);
            messageHelper('', 'error', 6000, e);
            throw e;
          }
        }
      }
    },


    /**
     *
     * @param {Object} ctx
     * @param {String} data Фамилия для поиска
     */
    async GET_TEAM_INDIVIDUAL(ctx, data) {
      try {
        const res = await axios.get(`${INDIVIDUAL_URL}?last_name=${data}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });

        await ctx.commit('UPDATE_INDIVIDUAL', res);
        return res.data;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e;
      }
    },

    async PROPOSAL_CHANGE_TEAM(ctx, data) {
      try {
        const res = await axios.post(PROPOSAL_CHANGE_TEAM_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        if(res.data && res.data.status == true)
          await ctx.commit('UPDATE_TEAM', res.data.all_teams)
        return res.data;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e;
      }
    },


    async PROPOSAL_GET_TEAM(ctx, data) {
      try {
        const res = await axios.get(`${PROPOSAL_CHANGE_TEAM_URL}?proposal_id=${data}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e;
      }
    },

    /**
     * Отправляет файл
     * @param {Object} ctx
     * @param {Object} data Данные для отправки файла
     * @returns {Object} Результат записис файла
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async FILE_SEND(ctx, data) {
      try {
        const res = await axios.post(FILE_POST_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e;
      }
    },

    async GET_FILES_LIST(ctx, data) {
      try {
        const res = await axios.post(FILES_LIST_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e;
      }
    },

    /**
     * Удаляет файл
     * @param {Object} ctx
     * @param {String|Number} data Идентификатор
     * @returns {Object} Результат удаления файла
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async DELETE_FILE_SYNC(ctx, data) {
      try {
        const res = await axios.delete(`${FILE_POST_URL}?id=${data}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('qwe', e);
        throw e;
      }
    },

    async COMMENT_FILE_SYNC(ctx, data) {
      try {
        const res = await axios.patch(FILE_POST_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('qwe', e);
        throw e;
      }
    },

    /**
     * обновление изображения календаря
     * @param {Object} ctx
     * @param {Object} data Данные для отправки файла
     * @returns {Object} Результат записис файла
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
     async CALENDAR_UPLOAD(ctx, data) {
      try {
        const res = await axios.post(CALENDAR_UPLOAD_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e;
      }
    },

    /**
     * Обновляет статус proposal
     * @param {Object} ctx
     * @param {Object} data Данные для смены статуса proposal
     * @returns {Object} Рузьтат смены статуса
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async UPDATE_REQUEST_STATUS(ctx, data) {
      try {
        const res = await axios.post(REQUEST_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });

        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('UPDATE_REQUEST_STATUS', e);
        throw e;
      }
    },

    /**
     * Обновляет статус proposal NEW
     * @param {Object} ctx
     * @param {Object} data Данные для смены статуса proposal
     * @returns {Object} Результат смены статуса
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
     async UPDATE_PROPOSAL_STATUS(ctx, data) {
      try {
        const res = await axios.post(UPDATE_PROPOSAL_STATUS_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('UPDATE_PROPOSAL_STATUS', e);
        return {'data' : {'error' : e.message}}
        // throw e;
      }
    },

    async EXPERTISE_PROPOSAL(ctx, data) {
      try {
        const res = await axios.post(GET_EXPERT_PROPOSAL_LIST_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });

        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('EXPERTISE_PROPOSAL', e);
        throw e;
      }
    },

    /**
     *
     * @param {Object} ctx
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async GET_EXPER(ctx) {
      try {
        const res = await axios.get(`${INDIVIDUAL_URL}?role=expert`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });

        await ctx.commit('UPDATE_EXPER', res.data);
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e;
      }
    },

    /**
     * Получает данные по идентификатору и открывает ссылку с PDF документом
     * @param {Object} ctx
     * @param {Array|Object} data список идентификаторов
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async GET_URL_PRD(ctx, data) {
      try {
        const res = await axios.get(`${PDF_URL}?ids=[${data}]`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        await window.open(`${DOMEN}${res.data.url}`, '_blank');
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' erer');
        throw e;
      }
    },

    /**
     * export to excel
     * @param {Object} ctx
     * @param {Array|Object} data список идентификаторов
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
     async UPLOAD_LIST_TO_EXCEL(ctx, data) {
      try {
        const res = await axios.get(`${EXPORT_LIST_TO_EXCEL_URL}?ids=[${data.proposal_ids}]&type_id=${data.type_id}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return {url: `${DOMEN}${res.data.url}`};
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' erer');
        throw e;
      }
    },

    /**
     * export to excel
     * @param {Object} ctx
     * @param {Array|Object} data список идентификаторов
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
     async EXPORT_CALENDAR_EXCEL(ctx, data) {
      try {
        const res = await axios.post(EXPORT_CALENDAR_EXCEL_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return {url: `${DOMEN}${res.data.url}`};
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' erer');
        throw e;
      }
    },

    /**
     * export to word
     * @param {Object} ctx
     * @param {Array|Object} data список идентификаторов
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async UPLOAD_COUNCIL_TO_DOCX(ctx, data) {
      try {
        const res = await axios.get(`${COUNCIL_EXPORT_TO_DOCX_URL}?id=${data}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return {url: `${DOMEN}${res.data.url}`};
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' erer');
        throw e;
      }
    },
    
    /**
     * Получает детальную информацию и записывает
     * @param {Object} ctx
     * @param {String|Number} id Идентификатор
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async GET_INPUT_ALL(ctx, id) {
      try {
        const res = await axios.get(`${PROPOSAL_DETAIL_URL}?id=${id}&expand=[%22all%22]`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });

        await ctx.commit('UPDATE_INPUT_ALL', res.data);

        return res.data;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' GET_INPUT_ALL');
        throw e;
      }
    },

    /**
     * Добавляет комментарий BS
     * @param {Object} ctx
     * @param {Object} data Данные для добавления комментария
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async ADD_COMMENT(ctx, data) {
      try {
        await axios.post(ADD_COMMENT_BS_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('ADD_COMMENT', e);
        throw e;
      }
    },

    /**
     * Добавляет эксперимент
     * @param {Object} ctx
     * @param {Object} data Данные для добавления эксперимента
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     *
     */
    async ADD_EXPERIMENT(ctx, data) {
      try {
        await axios.post(ADD_EXPERIMENT_BS_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('ADD_EXPERIMENT', e);
        throw e;
      }
    },

    /**
     * Получение списка организаций
     * @param {Object} ctx
     * @returns {Object} Список организаций
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async ORGANIZATION_HEADERS(ctx) {
      try {
        const res = await axios.get(`${REFERENCES_URL}organization/list/`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });

        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e;
      }
    },

    /**
     * Получает список организаций по языку
     * @param {Object} ctx
     * @param {String} data Язык
     * @returns {object} Список организаций
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     *
     */
    async ORGANIZATION(ctx, data) {
      try {
        const res = await axios.get(`${REFERENCES_URL}organization/list/?lang=${data}`);

        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
      }
    },

    async ADD_COMMENT_BS_CARD(ctx, data) {
      try {
        const res = await axios.post(ADD_COMMENT_BS_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });

        await ctx.commit('UPDATE_INPUT_ALL_COMMENTS', res.data.data);
      } catch (e) {
        throw e;
      }
    },

    async PROPOSAL_BS_ACTION_CARD(ctx, data) {
      try {
        const res = await axios.post(PROPOSAL_BS_ACTION_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });

        return res.data;

      } catch (e) {
        throw e;
      }
    },


    /**
     * Получает список доступных действий в заявке
     * @param {Object} ctx
     * @param {String} data proposal_id
     * @returns {object} Список доступных действий
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     *
     */
     async GET_PROPOSAL_AVAILABLE_ACTIONS(ctx, data) {
      try {
        const res = await axios.get(`${PROPOSAL_AVAILABLE_ACTIONS_URL}?type=full&id=${data}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e;
      }
    },

    async GET_BASE_AVAILABLE_ACTIONS(ctx, data) {
      try {
        const res = await axios.get(`${PROPOSAL_AVAILABLE_ACTIONS_URL}?type=base`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          }
        });
        return res.data
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e;
      }
    },

    /**
     * Получает список stations и записывает
     * @param {Object} ctx
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async LOAD_EQUIMENT(ctx) {
      try {
        // equiment
        await axios.get(EQUIMENT_URL, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        })
          .then((res) => ctx.commit('UPDATE_EQUIMENT', res))
          .catch((e) => {
            errorHelper(e);
            messageHelper('', 'error', 6000, e);
          });

      } catch (ex) {
        console.log('ex store---> ', ex);
        messageHelper('', 'error', 6000, ex);
      }    
    },

      
    /**
     * Получает список BS и записывает
     * @param {Object} ctx
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async LOAD_BS(ctx) {
      try {
        await axios.get(BS_LIST_URL, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        })
          .then((res) => ctx.commit('UPDATE_BS', res))
          .catch((e) => {
            errorHelper(e);
            messageHelper('', 'error', 6000, e);
          });

      } catch (ex) {
        console.log('ex store---> ', ex);
        messageHelper('', 'error', 6000, ex);
      }    
    },

    /**
     * Получает список proposal_experts
     * @param {Object} ctx
     * @param {String} data proposal_id 
     * @returns {object} Список доступных действий
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     *
     */
    async GET_PROPOSAL_EXPERTS(ctx, data) {
      try {
        const res = await axios.patch(PROPOSAL_EXPERTS_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e;
      }
    },
    // /////


    async GET_ACTIONS_HISTORY(ctx, data) {
      try {
        const res = await axios.post(GET_ACTION_HISTORY_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, 'NEXT_PASS_STATUS');
        throw e;
      }
    },  


    async MAKE_LOAD_KISI_STATUS(ctx) {
      try {
        await axios.get(`${REFERENCES_URL}kisi/status/`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        })
          .then((res) => ctx.commit('UPDATE_KISI_STATUS', res.data))
          .catch((e) => {
            errorHelper(e);
            messageHelper('', 'error', 6000, e);
          });
      } catch (e) {
        console.log('ex store---> ', e);
        messageHelper('', 'error', 6000, e);
      }
    },
      
    
  },
  getters: {
    GETTERS_SHOW_HELPER_DIALOG(state){
      return state.show_helper_dialog;
    },

    GETTERS_SHOW_HELPER_DIALOG_DATA(state){
      return state.helper_data;
    },

    GETTERS_BASE_PROPOSAL_ID(state){
      return state.base_proposal_id;
    },
    GETTERS_LOGIN(state) {
      return state.isLoggedIn;
    },
    GETTERS_EQUIMENT(state) {
      return state.equiment;
    },
    GETTERS_INDIVIDUAL(state) {
      return state.individual;
    },
    GETTERS_EXPER(state) {
      return state.exper;
    },
    GETTERS_INPUT_ALL(state) {
      return state.inputAll;
    },
    GETTERS_NAME_USER(state) {
      return state.nameUser;
    },
    GETTERS_PROFILE(state) {
      return state.profile;
    },
    GETTERS_OVERLAY(state) {
      return state.overlay;
    },
    GETTERS_CURRENT_STATION(state) {
      return state.currentStation;
    },
    GETTERS_BS_LIST(state) {
      return state.bs_list;
    },
    GETTERS_BS_BY_ID: (state) => (id) => {
      return state.bs_list ? state.bs_list[id] : null
    },
    GETTERS_BS_LIST_BY_STATION_ID: (state) => (id) => {
      var res = []
      for(var bs in state.bs_list){
        state.bs_list[bs].station_ids.forEach((jtem) => {
          if(jtem == id)
            res.push(state.bs_list[bs])
        })
      }
      return res
    },
    GETTERS_STATION_BY_ID: (state) => (id) => {
      return state.stations[id]
    },
    GETTERS_STATIONS(state){
      return state.stations
    },

    GETTERS_KISI_STATUS(state){
      return state.kisi_status
    },

    GETTERS_NEED_LOAD_KISI_STATUS(state){
      return state.need_load_kisi_status
    },

  },
  modules: {
    User,
    ResetPassword,
    Registration,
    Proposal,
    PersonalData,
    Auth,
    Language,
    Calendar,
    ModeratorSearch,
    RoleList,
    Logout,
    Statistic,
    OldApplications,
    Council,
    Pass,
    Invitation,
    NewProposal,
  },
});
